import React, { FC } from 'react';

import getClassName from 'src/common/utils/getClassName';
import Svg from '../Svg';
import s from './BoatPlaceholderImage.module.scss';

const BoatPlaceholderImage: FC<Props> = ({ classNameModifier = '' }) => (
  <div className={getClassName(s, 'root', classNameModifier)}>
    {classNameModifier.includes('avatar') && (
      <Svg
        href="#boat-icon"
        className={s.image}
      />
    )}
  </div>
);

type Props = {
  classNameModifier?: string;
};

export default BoatPlaceholderImage;
